import { AxiosResponse } from 'axios';
import { FeedbackMailRequestBody } from '../typings/mail';
import { PathsAPI } from '../routes/paths';
import { axiosInstance } from '../shared/axios';

// Send feedback
export const sendFeedback = async (
  body: FeedbackMailRequestBody,
): Promise<AxiosResponse<void>> => {
  return axiosInstance.post(PathsAPI.feedback, body);
};
